module.exports = __webpack_public_path__ + "img/icon_clock2.5961e4e9.png";